import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const TicketTablePagination = ({
  itemsPerPage,
  setCurrentPage,
  indexOfFirstItem,
  indexOfLastItem,
  totalItems,
}) => {
  const location = useLocation();
  const navigate = useNavigate(); // useNavigate replaces useHistory in v6
  const [currentPage, setPageState] = useState(1);

  // Calculate total pages
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));

  const syncPageWithURL = () => {
    const queryParams = new URLSearchParams(location.search);
    const page = parseInt(queryParams.get("page"), 10) || 1;

    if (page > totalPages) {
      navigate(`${location.pathname}?page=1`, { replace: true });
      setPageState(1);
      setCurrentPage(1);
    } else {
      setPageState(page);
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    syncPageWithURL();
  }, [location.search, totalPages]);

  const handlePrevPage = () => {
    if (currentPage > 1) {
      const newPage = currentPage - 1;
      setPageState(newPage);
      setCurrentPage(newPage);
      navigate(`${location.pathname}?page=${newPage}`);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      const newPage = currentPage + 1;
      setPageState(newPage);
      setCurrentPage(newPage);
      navigate(`${location.pathname}?page=${newPage}`);
    }
  };

  const RenderPageNumbers = () => (
    <p className="font-18-400-24 poppins-regular">
      {indexOfFirstItem + 1}-{Math.min(indexOfLastItem, totalItems)} of {totalItems}
    </p>
  );

  return (
    <div className="pagination flex items-center justify-end space-x-4">
      <RenderPageNumbers />
      <button
        onClick={handlePrevPage}
        className="size-50 border-dark-3 br-6 bg-transparent flex items-center justify-center"
        disabled={currentPage === 1}
      >
        <img src="./arrow-down.svg" className="rotate-90" />
      </button>
      <button
        onClick={handleNextPage}
        className="size-50 border-dark-3 br-6 bg-transparent flex items-center justify-center"
        disabled={currentPage === totalPages}
      >
        <img src="./arrow-down.svg" className="rotate--90" />
      </button>
    </div>
  );
};

export default TicketTablePagination;
